module.exports = __webpack_public_path__ + "img/bt.btef80804.svg";